import React from "react";
import { useProperties } from "../context/PropertyContext";
import { useLang } from "../context/LangContext";

export default function PropertySelector({ testid = "property-selector", includeAll = true }) {
  const { properties, approvedProperties, selectedId, setSelected } = useProperties();
  const { t } = useLang();
  const list = approvedProperties;
  if (properties.length <= 1 && !includeAll) return null;
  return (
    <select
      data-testid={testid}
      value={selectedId}
      onChange={(e) => setSelected(e.target.value)}
      className="border border-[#E5E1D8] rounded-lg px-3 py-2 text-sm bg-white"
    >
      {includeAll && <option value="all">{t("all_properties")}</option>}
      {list.map((p) => (
        <option key={p.id} value={p.id}>{p.name}</option>
      ))}
    </select>
  );
}
